import { api } from "#app/http/api";

type ConnectUserErrorCode = "INVALID_COMPANY_CODE" | "COMPANY_NOT_FOUND" | "CONNECTION_FAILED";
export class ConnectUserError extends Error {
  constructor(
    public code: ConnectUserErrorCode,
    message?: string,
  ) {
    super(message);
    this.name = "ConnectUserError";
  }
}

export const connectUser = async (companyId: string) => {
  const response = await api.company.connect.mutation({
    params: {
      id: companyId,
    },
    body: undefined,
  });

  if (response.status === 200) {
    return response.body;
  }

  if (response.status === 400) {
    throw new ConnectUserError("INVALID_COMPANY_CODE");
  }

  if (response.status === 404) {
    throw new ConnectUserError("COMPANY_NOT_FOUND");
  }

  throw new ConnectUserError("CONNECTION_FAILED");
};
